import { mergeSearchParams } from '../../../searchParams';
import constructSourceId from './constructSourceId';
import { SOURCE_KEY } from './Constants';

/**
 * @parm inputUrl:String - fully-qualified URL having #sourceid-suffix and possibly searchParams
 * @parm meta:Obj - { location:Obj|WindowObj, sourceid:String|CookieValue } - 
 * @return URL:String - without hash, having sourceid and all other search params
 *
 * Hierarchy: 
 * if location (current visit) contains sourceid, then it supersedes all
 * Else if persisted cookie value include sourceid, then construct and forward that
 * Else construct new sourceid using path and suffix
 */

const replaceSourceIdHash = (inputUrl, meta) => 
{
    const { location, sourceid } = meta;
    const newSearchParams = new URLSearchParams(location?.search);
    const newSourceIdValue = newSearchParams.get(`${SOURCE_KEY}`)
    if (newSourceIdValue) 
    {
        newSearchParams.set(`${SOURCE_KEY}`, `${newSourceIdValue.substring(0, 99)}`)
    }
    const persistedSourceIdParam = sourceid ? `${SOURCE_KEY}=${sourceid}` : undefined;
    const fwdSearchParams = mergeSearchParams(persistedSourceIdParam, newSearchParams);

    const url = new URL(inputUrl);
    if (!fwdSearchParams.has(SOURCE_KEY)) 
    {
        const hashSuffix = url.hash.split('-').pop();
        fwdSearchParams.set(SOURCE_KEY, constructSourceId(location, hashSuffix));
    }

    const mergedSearchParams = mergeSearchParams(
        fwdSearchParams,
        url.searchParams
    );

    url.search = mergedSearchParams.toString();
    url.hash = '';
    return url.toString();
};

const sourceid = (content, meta) => (content || '').replace(
    /http[^ '"]+\#sourceid[\w\-]*/g,
    (inputUrl) => replaceSourceIdHash(inputUrl, meta)
)

export default sourceid;
export { replaceSourceIdHash };
